import { colorsPalettes } from "@similarweb/styles";

export const getFilterModalCloseIconConfig = (onClick: () => void) => ({
    show: false,
    color: colorsPalettes.carbon[0],
    onClick,
});

export const filterModalStyles = {
    content: { padding: "0", border: "unset", width: "592px", borderRadius: "6px" },
};
